<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout wrap>
      <v-flex md12 sm12 lg6>
        <material-chart-card
          :data="DailyPunctualityChart.data"
          :options="DailyPunctualityChart.options"
          color="info"
          type="Line"
        >
          <h4 class="title font-weight-light">
            Current Month Daywise Punctuality
          </h4>
          <p class="category d-inline-flex font-weight-light">
            Progressive Punctuality &nbsp;
            <span class="green--text">{{ avgPunctuality }}%</span>&nbsp;
            <v-icon color="green" small> mdi-arrow-up </v-icon>
          </p>

          <template v-slot:activator="{ on }">
            <v-icon class="mr-2" small> mdi-clock-outline </v-icon>
            <span class="caption grey--text font-weight-light"
              >updated 4 minutes ago</span
            >
          </template>
        </material-chart-card>
      </v-flex>
      <v-flex md12 sm12 lg6>
        <material-chart-card
          :data="trainWisePerformanceChart.data"
          :options="trainWisePerformanceChart.options"
          :responsive-options="trainWisePerformanceChart.responsiveOptions"
          color="red"
          type="Bar"
        >
          <h4 class="title font-weight-light">
            Train wise Average Late(in mnts)
          </h4>
          <p class="category d-inline-flex font-weight-light">
            Current Month Performance
          </p>

          <template v-slot:activator="{ on }">
            <v-icon class="mr-2" small> mdi-clock-outline </v-icon>
            <span class="caption grey--text font-weight-light"
              >updated 10 minutes ago</span
            >
          </template>
        </material-chart-card>
      </v-flex>
      <v-flex md12 sm12 lg12>
        <material-chart-card
          :data="rakeWisePerformanceChart.data"
          :options="rakeWisePerformanceChart.options"
          color="green"
          type="Bar"
        >
          <h3 class="title font-weight-light">
            Rake wise Average Late(in mnts)
          </h3>
          <p class="category d-inline-flex font-weight-light">
            Current month Performance
          </p>

          <template v-slot:activator="{ on }">
            <v-icon class="mr-2" small> mdi-clock-outline </v-icon>
            <span class="caption grey--text font-weight-light"
              >updated 26 minutes ago</span
            >
          </template>
        </material-chart-card>
      </v-flex>
      <v-flex sm6 xs12 md6 lg3>
        <material-stats-card
          color="green"
          icon="mdi-crosshairs-gps"
          title="Active"
          :value="gps_active"
          sub-icon="mdi-calendar"
          sub-text="Last 24 Hours"
        />
      </v-flex>
      <v-flex sm6 xs12 md6 lg3>
        <material-stats-card
          color="orange"
          icon="mdi-crosshairs-gps"
          title="Inactive"
          :value="gps_inactive"
          small-value="No"
          sub-icon="mdi-alert"
          sub-icon-color="error"
          sub-text="activate..."
          sub-text-color="text-primary"
        />
      </v-flex>
      <v-flex sm6 xs12 md6 lg3>
        <material-stats-card
          color="red"
          icon="mdi-crosshairs-gps"
          title="Off line"
          :value="gps_offline"
          sub-icon="mdi-tag"
          sub-text="Trouble shoot..."
        />
      </v-flex>
      <v-flex sm6 xs12 md6 lg3>
        <material-stats-card
          color="info"
          icon="mdi-calendar-clock"
          title="Punctuality(%)"
          :value="todaysPuntuality"
          small-value="%"
          sub-icon="mdi-update"
          sub-text="Just Updated"
        />
      </v-flex>
      <!-- <v-flex md12 lg12>
      <material-card color="orange" title="Punctuality" text="Train Report">
        <TrainsReport></TrainsReport>
      </material-card>
    </v-flex>
    <v-flex md12 lg12>
      <material-card color="green" title="Device Status" text="Devices on 10th Jan, 2020">
        <devices></devices>
      </material-card>
    </v-flex> -->
      <!-- <v-flex
        md12
        lg6
      >
        <material-card
          color="orange"
          title="Device Status"
          text="Devices on 10th Jan, 2020"
        >
          <v-data-table
            :headers="headers"
            :items="items"
            hide-default-footer
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="font-weight-light text-warning text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ index, item }"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td class="text-xs-right">{{ item.salary }}</td>
              <td class="text-xs-right">{{ item.country }}</td>
              <td class="text-xs-right">{{ item.city }}</td>
            </template>
          </v-data-table>
        </material-card>
      </v-flex> -->

      <!-- <v-flex
        md12
        lg6
      >
        <material-card
          class="card-tabs"
          color="green">
          <v-flex
            slot="header"
          >
            <v-tabs
              v-model="tabs"
              color="transparent"
              slider-color="white"
            >
              <span
                class="subheading font-weight-light mr-3"
                style="align-self: center"
              >Tasks:</span>
              <v-tab class="mr-3">
                <v-icon class="mr-2">mdi-bug</v-icon>
                Bugs
              </v-tab>
              <v-tab class="mr-3">
                <v-icon class="mr-2">mdi-code-tags</v-icon>
                Website
              </v-tab>
              <v-tab>
                <v-icon class="mr-2">mdi-cloud</v-icon>
                Server
              </v-tab>
            </v-tabs>
          </v-flex>

          <v-tabs-items v-model="tabs">
            <v-tab-item
              v-for="n in 3"
              :key="n"
            >
              <v-list three-line>
                <v-list-item @click="complete(0)">
                  <v-list-item-action>
                    <v-checkbox
                      :value="list[0]"
                      color="green"
                    />
                  </v-list-item-action>
                  <v-list-item-title>
                    Sign contract for "What are conference organized afraid of?"
                  </v-list-item-title>
                  <div class="d-flex">
                    <v-tooltip
                      top
                      content-class="top">
                      <v-btn
                        v-slot:activator="{ on }"
                        class="v-btn--simple"
                        color="success"
                        icon
                      >
                        <v-icon color="primary">mdi-pencil</v-icon>
                      </v-btn>
                      <span>Edit</span>
                    </v-tooltip>
                    <v-tooltip
                      top
                      content-class="top">
                      <v-btn
                        v-slot:activator="{ on }"
                        class="v-btn--simple"
                        color="danger"
                        icon
                      >
                        <v-icon color="error">mdi-close</v-icon>
                      </v-btn>
                      <span>Close</span>
                    </v-tooltip>

                  </div>
                </v-list-item>
                <v-divider/>
                <v-list-item @click="complete(1)">
                  <v-list-item-action>
                    <v-checkbox
                      :value="list[1]"
                      color="success"
                    />
                  </v-list-item-action>
                  <v-list-item-title>
                    Lines From Great Russian Literature? Or E-mails From My Boss?
                  </v-list-item-title>
                  <div class="d-flex">
                    <v-tooltip
                      top
                      content-class="top">
                      <v-btn
                        v-slot:activator="{ on }"
                        class="v-btn--simple"
                        color="success"
                        icon
                      >
                        <v-icon color="primary">mdi-pencil</v-icon>
                      </v-btn>
                      <span>Edit</span>
                    </v-tooltip>

                    <v-tooltip
                      top
                      content-class="top">
                      <v-btn
                        v-slot:activator="{ on }"
                        class="v-btn--simple"
                        color="danger"
                        icon>
                        <v-icon color="error">mdi-close</v-icon>
                      </v-btn>
                      <span>Close</span>
                    </v-tooltip>
                  </div>
                </v-list-item>
                <v-divider/>
                <v-list-item @click="complete(2)">
                  <v-list-item-action>
                    <v-checkbox
                      :value="list[2]"
                      color="success"
                    />
                  </v-list-item-action>
                  <v-list-item-title>
                    Flooded: One year later, assessing what was lost and what was found when a ravaging rain swept through metro Detroit
                  </v-list-item-title>
                  <div class="d-flex">
                    <v-tooltip
                      top
                      content-class="top">
                      <v-btn
                        v-slot:activator="{ on }"
                        class="v-btn--simple"
                        color="success"
                        icon
                      >
                        <v-icon color="primary">mdi-pencil</v-icon>
                      </v-btn>
                      <span>Edit</span>
                    </v-tooltip>
                    <v-tooltip
                      top
                      content-class="top">
                      <v-btn
                        v-slot:activator="{ on }"
                        class="v-btn--simple"
                        color="danger"
                        icon
                      >
                        <v-icon color="error">mdi-close</v-icon>
                      </v-btn>
                      <span>Close</span>
                    </v-tooltip>

                  </div>
                </v-list-item>
              </v-list>
            </v-tab-item>
          </v-tabs-items>
        </material-card>
      </v-flex> -->
    </v-layout>
  </v-container>
</template>

<script>
import TrainsReport from "./trainsreport.vue";
import devices from "./devices.vue";
import moment from "moment";
import _ from "lodash";
import axios from "axios";
import { Carousel, Slide } from "vue-carousel";
export default {
  components: {
    TrainsReport,
    devices,
  },
  data() {
    return {
      DailyPunctualityChart: {
        data: {
          labels: ["M", "T", "W", "T", "F", "S", "S"],
          series: [[12, 17, 7, 17, 23, 18, 38]],
        },
        options: {
          lineSmooth: this.$chartist.Interpolation.cardinal({
            tension: 0,
          }),
          low: 0,
          high: 100, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
          },
        },
      },
      avgPunctuality: 0,
      trainWisePerformanceChart: {
        data: {
          labels: ["12am", "3pm", "6pm", "9pm", "12pm", "3am", "6am", "9am"],
          series: [[230, 750, 450, 300, 280, 240, 200, 190]],
        },
        options: {
          lineSmooth: this.$chartist.Interpolation.cardinal({
            tension: 0,
          }),
          low: 0,
          high: 30, // creative tim: we recommend you to set the high sa the biggest value + something for a better look
          chartPadding: {
            top: 20,
            right: 5,
            bottom: 5,
            left: 5,
          },
        },
      },
      rakeWisePerformanceChart: {
        data: {
          labels: [
            "Ja",
            "Fe",
            "Ma",
            "Ap",
            "Mai",
            "Ju",
            "Jul",
            "Au",
            "Se",
            "Oc",
            "No",
            "De",
          ],
          series: [
            [542, 443, 320, 780, 553, 453, 326, 434, 568, 610, 756, 895],
          ],
        },
        options: {
          axisX: {
            showGrid: false,
          },
          low: 0,
          high: 30,
          chartPadding: {
            top: 20,
            right: 5,
            bottom: 5,
            left: 5,
          },
        },
        responsiveOptions: [
          [
            "screen and (max-width: 640px)",
            {
              seriesBarDistance: 5,
              axisX: {
                labelInterpolationFnc: function (value) {
                  return value[0];
                },
              },
            },
          ],
        ],
      },
      headers: [
        {
          sortable: false,
          text: "ID",
          value: "id",
        },
        {
          sortable: false,
          text: "Name",
          value: "name",
        },
        {
          sortable: false,
          text: "Salary",
          value: "salary",
          align: "right",
        },
        {
          sortable: false,
          text: "Country",
          value: "country",
          align: "right",
        },
        {
          sortable: false,
          text: "City",
          value: "city",
          align: "right",
        },
      ],
      items: [
        {
          name: "Dakota Rice",
          country: "Niger",
          city: "Oud-Tunrhout",
          salary: "$35,738",
        },
        {
          name: "Minerva Hooper",
          country: "Curaçao",
          city: "Sinaai-Waas",
          salary: "$23,738",
        },
        {
          name: "Sage Rodriguez",
          country: "Netherlands",
          city: "Overland Park",
          salary: "$56,142",
        },
        {
          name: "Philip Chanley",
          country: "Korea, South",
          city: "Gloucester",
          salary: "$38,735",
        },
        {
          name: "Doris Greene",
          country: "Malawi",
          city: "Feldkirchen in Kārnten",
          salary: "$63,542",
        },
      ],
      caroselitems: [
        {
          src: require("../assets/liveview.png"),
        },
        {
          src: require("../assets/ppt/ssts/Slide8.jpg"),
        },
        // {
        //   src: require('../assets/ppt/ssts/Slide3.PNG'),
        // },
        // {
        //   src: require('../assets/ppt/ssts/Slide4.PNG'),
        // },{
        //   src: require('../assets/ppt/ssts/Slide5.PNG'),
        // },
        // {
        //   src: require('../assets/ppt/ssts/Slide6.PNG'),
        // },
        // {
        //   src: require('../assets/ppt/ssts/Slide7.PNG'),
        // },
        // {
        //   src: require('../assets/ppt/ssts/Slide8.PNG'),
        // }
      ],
      tabs: 0,
      list: {
        0: false,
        1: false,
        2: false,
      },
      device: {},
      device_loading: false,
      devices: [],
      device_status: {
        green: 0,
        orange: 0,
        red: 0,
        total: 0,
      },
      gps_active: "0",
      gps_inactive: "0",
      gps_offline: "0",
      todaysPuntuality: "",
    };
  },
  created() {
    this.getDailyPuntuality();
    this.getTrainPerformance();
    this.getRakePerformance();
    this.getDevices();
    this.getTodaysPuntuality();
  },
  methods: {
    getDailyPuntuality() {
      // this.updateCurTrainDate(moment(this.train_date).format("YYYY-MM-DD"))
      // //      console.log(this.curDeviceId)
      // this.isLoading = true

      var p = {
        start_date: moment().startOf("month").format("YYYY-MM-DD"),
        end_date: moment().endOf("day").format("YYYY-MM-DD"),
      };
      axios.defaults.headers.common["Authorization"] =
        localStorage.getItem("jwtToken");
      axios
        .get(`${process.env.VUE_APP_API_URL}/train/tr/punctuality_for_period`, {
          params: p,
        })
        .then((response) => {
          var labels_data = [];
          var series_data = [];
          var punctuality = 0;
          if (response.data.length > 0) {
            for (var i = 0; i < response.data.length; i++) {
              var o = response.data[i];
              labels_data.push(this.getFormattedTime(o.train_date));
              punctuality += Math.round(
                (o.no_of_rt_train / o.no_of_train) * 100,
                2
              );
              series_data.push(
                Math.round((o.no_of_rt_train / o.no_of_train) * 100, 2)
              );
            }
            this.avgPunctuality = Math.round(
              punctuality / response.data.length,
              2
            );
            this.DailyPunctualityChart.data.labels = labels_data;
            this.DailyPunctualityChart.data.series = [];
            this.DailyPunctualityChart.data.series.push(series_data);
            //      console.log(this.DailyPunctualityChart.data);
          }
        })
        .catch((e) => {
          console.log(e);
          this.isLoading = false;
        });
    },
    getTodaysPuntuality() {
      // this.updateCurTrainDate(moment(this.train_date).format("YYYY-MM-DD"))
      // //      console.log(this.curDeviceId)
      // this.isLoading = true

      var p = {
        start_date: moment().format("YYYY-MM-DD"),
        end_date: moment().format("YYYY-MM-DD"),
      };
      axios.defaults.headers.common["Authorization"] =
        localStorage.getItem("jwtToken");
      axios
        .get(`${process.env.VUE_APP_API_URL}/train/tr/punctuality_for_period`, {
          params: p,
        })
        .then((response) => {
          if (response.data[0]) {
            this.todaysPuntuality = Math.round(
              (response.data[0].no_of_rt_train / response.data[0].no_of_train) *
                100,
              2
            );
          }
          console.log(this.DailyPunctualityChart.data);
        })
        .catch((e) => {
          console.log(e);
          this.isLoading = false;
        });
    },
    getTrainPerformance() {
      // this.updateCurTrainDate(moment(this.train_date).format("YYYY-MM-DD"))
      // //      console.log(this.curDeviceId)
      // this.isLoading = true

      var p = {
        start_date: moment().startOf("month").format("YYYY-MM-DD"),
        end_date: moment().endOf("day").format("YYYY-MM-DD"),
      };
      axios.defaults.headers.common["Authorization"] =
        localStorage.getItem("jwtToken");
      axios
        .get(
          `${process.env.VUE_APP_API_URL}/train/tr/train_wise_summ_for_period`,
          {
            params: p,
          }
        )
        .then((response) => {
          var labels_data = [];
          var series_data = [];
          if (response.data.length > 0) {
            for (var i = 0; i < 10; i++) {
              var o = response.data[i];
              labels_data.push(o.train_no);
              series_data.push(Math.round(o.avg_late_arr / 60, 0));
            }
            this.trainWisePerformanceChart.data.labels = labels_data;
            this.trainWisePerformanceChart.data.series = [];
            this.trainWisePerformanceChart.data.series.push(series_data);
            console.log(this.trainWisePerformanceChart.data);
          }
        })
        .catch((e) => {
          console.log(e);
          this.isLoading = false;
        });
    },
    getRakePerformance() {
      // this.updateCurTrainDate(moment(this.train_date).format("YYYY-MM-DD"))
      // //      console.log(this.curDeviceId)
      // this.isLoading = true

      var p = {
        start_date: moment().startOf("month").format("YYYY-MM-DD"),
        end_date: moment().endOf("day").format("YYYY-MM-DD"),
      };
      axios.defaults.headers.common["Authorization"] =
        localStorage.getItem("jwtToken");
      axios
        .get(
          `${process.env.VUE_APP_API_URL}/train/tr/rake_wise_summ_for_period`,
          {
            params: p,
          }
        )
        .then((response) => {
          var labels_data = [];
          var series_data = [];
          if (response.data.length > 0) {
            for (var i = 0; i < 10; i++) {
              var o = response.data[i];
              labels_data.push(o.device_name);
              series_data.push(Math.round(o.avg_late_arr / 60, 0));
            }
            this.rakeWisePerformanceChart.data.labels = labels_data;
            this.rakeWisePerformanceChart.data.series = [];
            this.rakeWisePerformanceChart.data.series.push(series_data);
            //          console.log(this.rakeWisePerformanceChart.data);
          }
        })
        .catch((e) => {
          console.log(e);
          this.isLoading = false;
        });
    },
    getDevices() {
      axios.defaults.headers.common["Authorization"] =
        localStorage.getItem("jwtToken");
      axios
        .get(`${process.env.VUE_APP_API_URL}/device`)
        .then((response) => {
          this.devices = [];
          if (response.data.length > 0) {
            //        console.log(response.data)
            _.assign(this.device_status, {
              green: 0,
              orange: 0,
              red: 0,
              total: 0,
            });
            this.devices = response.data;
            _.forEach(response.data, (device) => {
              this.device_status[this.getColour(device.lastupdate)]++;
              this.device_status["total"]++;
            });
            this.gps_active = this.device_status.green + "";
            this.gps_inactive = this.device_status.orange + "";
            this.gps_offline = this.device_status.red + "";
          }
        })
        .catch((e) => {
          if (e.status === 401) {
            console.log(e);
            this.$router.push({
              name: "Login",
            });
          }
        });
    },
    getFormattedTime(t) {
      var lt = moment(t).format("YYYY-MM-DD HH:mm:ss");
      var testDateUtc = moment.utc(lt);
      var localDate = moment(testDateUtc).local();
      return localDate.format("D");
    },
    getColour(t) {
      if (t) {
        var lt = moment(t).format("YYYY-MM-DD HH:mm:ss");
        var testDateUtc = moment.utc(lt);
        var localDate = moment(testDateUtc).local();
        var duration = moment().diff(localDate, "minutes");
        return duration > 5 ? "orange" : "green";
      } else {
        return "red";
      }
    },
    complete(index) {
      this.list[index] = !this.list[index];
    },
  },
};
</script>
